module.exports = __webpack_public_path__ + "img/edit.ad665059.svg";